module.exports = __webpack_public_path__ + "img/logo-7215.2906364c.png";